import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { RefreshIcon } from './Icons';
import { UseTranslate } from '../../hooks/Translate';
import {
  otpLimitText,
  OTP_RESEND_INTERVAL,
  RECOVERY_BLOCKED,
} from '../../utils/otpLimit';

interface ICounterProps {
  refreshCount: number | undefined;
  onRetry: () => void;
  seconds: number;
  // forgot-password codes: timers from internal-cas, shown like the cas login page
  resendRemainingSec?: number;
  blockRemainingSec?: number;
}

export const Counter = (props: ICounterProps) => {
  const [seconds, setSeconds] = useState(props.seconds);
  const [blockSeconds, setBlockSeconds] = useState(0);
  const [translate] = UseTranslate();
  const limited =
    props.resendRemainingSec !== undefined ||
    props.blockRemainingSec !== undefined;

  useEffect(() => {
    if (seconds <= 0 && blockSeconds <= 0) {
      return;
    }
    const timeout = setTimeout(() => {
      setSeconds((value) => Math.max(value - 1, 0));
      setBlockSeconds((value) => Math.max(value - 1, 0));
    }, 1000);

    return () => clearTimeout(timeout);
  }, [seconds, blockSeconds]);

  useEffect(() => {
    if (props.refreshCount !== undefined) {
      setSeconds(props.resendRemainingSec ?? props.seconds);
      setBlockSeconds(props.blockRemainingSec ?? 0);
    }
  }, [
    props.refreshCount,
    props.seconds,
    props.resendRemainingSec,
    props.blockRemainingSec,
  ]);

  if (props.refreshCount === undefined) {
    return (
      <div className="small my-4 d-flex justify-content-center">
        <Spinner animation="border" size="sm" className="text-muted" />
      </div>
    );
  }

  if (limited) {
    const blocked = seconds <= 0 && blockSeconds > 0;

    return (
      <div className="small my-4 text-center">
        <div className="text-muted">
          {seconds > 0 ? (
            <span className="mx-1">
              {otpLimitText(translate, OTP_RESEND_INTERVAL, seconds)}
            </span>
          ) : (
            <>
              {blocked && (
                <div className="mb-1" style={{ color: '#f11c53' }}>
                  {otpLimitText(translate, RECOVERY_BLOCKED, blockSeconds)}
                </div>
              )}
              <button
                type="button"
                className="resend-button"
                onClick={props.onRetry}
                disabled={blocked}
              >
                {!blocked && <RefreshIcon />}
                <span className="mx-1">
                  {translate('cas.registration.codeResend')}
                </span>
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="small my-4 d-flex justify-content-center">
      <div className="text-muted">
        <span
          onClick={() => (!seconds ? props.onRetry() : null)}
          className="linkSpan"
        >
          <RefreshIcon />
          <span className="mx-1">
            {translate('cas.registration.codeResend')}
          </span>
        </span>
      </div>
      {seconds > 0 ? <span className="resend-timer">({seconds})</span> : ''}
    </div>
  );
};
